/**
 * 毛坯房精装-图片控制
 * @returns
 */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";
import SmroomImageComparing from "./smroomImageComparing";
import { Content } from "@/types/content";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  bigImage: Content;
};

const BigPictureModal = (props: Props) => {
  const { isOpen, onClose, bigImage } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent
        // h="80vh"
        // background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
        // background="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
        bg="#172248"
      >
        <ModalHeader color="#27314D" fontSize={"18px"}></ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody >
          <Box h="70vh">
            <Box w="100%" h="100%">
              {bigImage && (
                <SmroomImageComparing
                  isOpen={isOpen}
                  image={bigImage}
                  compareImageSrc={bigImage.ref_structure}
                />
              )}
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BigPictureModal;
